/**
 * FursCertificate API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import {
  deleteFursCertificate,
  getFursCertificate,
  uploadFursCertificate,
} from "../generated/furs-certificate/furs-certificate";

import { wrapMethod } from "./utils";

export const fursCertificate = {
  /** @see uploadFursCertificate */
  uploadFursCertificate: wrapMethod(uploadFursCertificate),

  /** @see getFursCertificate */
  getFursCertificate: wrapMethod(getFursCertificate),

  /** @see deleteFursCertificate */
  delete: wrapMethod(deleteFursCertificate),
} as const;

export type FursCertificateApi = typeof fursCertificate;
